import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownPipe } from 'ngx-markdown';
import { BaaScrollContainerComponent } from '../baa-scroll-container';
import { BaaSignModalStore } from '../baa-sign-modal.store';

@Component({
  selector: 'lib-baa-authorized-signer-details',
  standalone: true,
  imports: [AsyncPipe, CommonModule, ReactiveFormsModule, TranslateModule, InputComponent, BaaScrollContainerComponent, MarkdownPipe],
  templateUrl: './baa-authorized-signer-details.component.html',
  styleUrl: './baa-authorized-signer-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaAuthorizedSignerDetailsComponent {
  protected readonly modalStore = inject(BaaSignModalStore);

  private readonly fb = inject(FormBuilder);

  protected readonly form: FormGroup = this.fb.group({
    fullName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
  });

  protected readonly isSubmitted = signal(false);

  public get isDirty(): boolean {
    return this.form.dirty;
  }

  protected onSubmit(): void {
    this.isSubmitted.set(true);
    if (this.form.invalid) {
      return;
    }
    const { fullName, email } = this.form.getRawValue();
    this.modalStore.sendSignerRequest({ fullName, email });
  }
}
